// removed by extract-text-webpack-plugin
module.exports = {"disabled":"qempo_UnsubscribeSuccess_disabled-24fesV5","unsubscriptionSuccessWrap":"qempo_UnsubscribeSuccess_unsubscriptionSuccessWrap-10AE5zR","unsubscriptionSuccess":"qempo_UnsubscribeSuccess_unsubscriptionSuccess-2lG6Trd","yogi":"qempo_UnsubscribeSuccess_yogi-3aYEmSK","title":"qempo_UnsubscribeSuccess_title-2jnibhO","subtitle":"qempo_UnsubscribeSuccess_subtitle-IiMTfpn","separator":"qempo_UnsubscribeSuccess_separator-nTIpOPM","bottomWrap":"qempo_UnsubscribeSuccess_bottomWrap-ohJK5u3","save":"qempo_UnsubscribeSuccess_save-3Cf8nZ5"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/unsubscribe/components/UnsubscribeSuccess.scss
// module id = 2213
// module chunks = 0